import React, { ReactNode } from 'react';

import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { SvgIconOwnProps } from '@mui/material';

import classes from './StarText.module.scss';

type StarTextProps = {
  children: ReactNode;
  size?: SvgIconOwnProps['fontSize'];
};

const StarText = ({ children, size = 'large' }: StarTextProps) => {
  return (
    <div className={classes.textContainer}>
      <StarRoundedIcon fontSize={size} color="warning" />
      <span>{children}</span>
    </div>
  );
};

export { StarText };
